import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6553e49a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-black-body m-3" }
const _hoisted_2 = { class: "flex text-white justify-center items-center p-3 lg:p-10" }
const _hoisted_3 = { class: "w-full md:w-100 bg-black-primary" }
const _hoisted_4 = {
  key: 0,
  class: "text-danger-primary bg-danger-background text-sm p-3"
}
const _hoisted_5 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Please refer to ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Settings ")
const _hoisted_8 = {
  key: 1,
  class: "text-danger-primary bg-danger-background text-sm p-3"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Public Key is not available or wallet is not connected.", -1))
const _hoisted_10 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Please refer to ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Settings ")
const _hoisted_13 = { class: "mb-5 lg:mb-10 grid grid-cols-2" }
const _hoisted_14 = {
  key: 0,
  class: "py-0 px-4 lg:px-10"
}
const _hoisted_15 = {
  key: 1,
  class: "px-4 pb-5 lg:px-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_tokensCreateAssetFormComponent = _resolveComponent("tokensCreateAssetFormComponent")!
  const _component_tokensImportAssetComponent = _resolveComponent("tokensImportAssetComponent")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isInsufficientBalance)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", null, "This account has insufficient XPX. Balance of minumum 1,500 xpx is required in your " + _toDisplayString(_ctx.network) + " wallet to create token.", 1),
                (_ctx.network=='Testnet')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _hoisted_6,
                      _createVNode(_component_router_link, {
                        to: { name: 'viewHomeSettings'},
                        class: "hover:underline hover:text-blue-primary transition-all duration-200 font-bold"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7,
                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-arrow-up-right-from-square" })
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" to top up " + _toDisplayString(_ctx.testnetLabel) + " XPX into your Sirius " + _toDisplayString(_ctx.testnetLabel) + " Wallet", 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isInvalidPublicKey)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                (_ctx.network=='Testnet')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _hoisted_11,
                      _createVNode(_component_router_link, {
                        to: { name: 'viewHomeSettings'},
                        class: "hover:underline hover:text-blue-primary transition-all duration-200 font-bold"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12,
                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-arrow-up-right-from-square" })
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" to reconnect your Sirius " + _toDisplayString(_ctx.testnetLabel) + " Wallet", 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", {
                class: _normalizeClass(["text-white text-center font-semibold text-xs sm:text-sm p-5 lg:p-7", { 'bg-black-body cursor-pointer hover:bg-black-sidebar transition-all duration-200':(_ctx.selectedComponent == 'import') }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedComponent = 'create'))
              }, "Create " + _toDisplayString(_ctx.network) + " Token", 3),
              _createElementVNode("div", {
                class: _normalizeClass(["text-white text-center font-semibold text-xs sm:text-sm p-5 lg:p-7", { 'bg-black-body cursor-pointer hover:bg-black-sidebar transition-all duration-200':(_ctx.selectedComponent == 'create') }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedComponent = 'import'))
              }, "Import Existing " + _toDisplayString(_ctx.network) + " Token", 3)
            ]),
            (_ctx.selectedComponent == 'create')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_tokensCreateAssetFormComponent, { isInsufficientBalance: _ctx.isInsufficientBalance }, null, 8, ["isInsufficientBalance"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_tokensImportAssetComponent, { publicKey: _ctx.publicKey }, null, 8, ["publicKey"])
                ]))
          ])
        ])
      ])
    ])
  ]))
}